// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@conklin/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import { css } from "styled-components";

linkListStyles.title = {
    variant: "h6",
    forwardAs: "h6",
    css: css`
        margin-bottom: 8px;
    `,
};

linkListStyles.linkListWrapper = {};

linkListStyles.linkWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: ${({ gap }: any) => gap}px;

        &.horizontal {
            flex-direction: row;

            ${({ separator, gap }: any) =>
                separator &&
                css`
                    ${StyledButton}:not(:last-of-type)::after {
                        content: "|";
                        color: ${color("common.ui5")};
                        padding-left: ${gap}px;
                    }
                `}
        }
    `,
};

linkListStyles.link = {
    mergeCss: true,
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.regular,
        forwardAs: "p",
        css: css`
            &&&& {
                line-height: 17px;
            }
        `,
    },
};
